// src/pages/Users/Produits/components/AuthorCard.jsx

import React from "react";
import {
  FaEnvelope,
  FaLaptopCode,
  FaPhoneAlt,
  FaUserTie,
} from "react-icons/fa";

import VKardLink from "./VKardLink";

const AUTHOR_PHOTO =
  "/img/illustration_LV_MAC3.png";

export default function AuthorCard() {
  return (
    <section className="overflow-hidden rounded-[2rem] border border-slate-200 bg-white shadow-sm dark:border-slate-800 dark:bg-slate-900">
      <div className="relative bg-gradient-to-r from-slate-950 via-blue-900 to-violet-800 p-5 text-white sm:p-6">
        <div className="pointer-events-none absolute -right-14 -top-14 h-36 w-36 rounded-full bg-white/10 blur-3xl" />

        <div className="relative flex flex-col gap-5 sm:flex-row sm:items-center">
          <img
            src={AUTHOR_PHOTO}
            alt="Laurent Victorin"
            className="h-28 w-28 rounded-[2rem] object-cover ring-4 ring-white/20"
            loading="lazy"
          />

          <div>
            <p className="text-xs font-bold uppercase tracking-[0.22em] text-sky-200">
              Développeur & homme de terrain
            </p>

            <h3 className="mt-2 text-2xl font-bold">Laurent VICTORIN</h3>

            <p className="mt-2 max-w-2xl text-sm leading-6 text-white/85">
              Auto-entrepreneur, développeur web full stack, président et
              enseignant de judo. Je conçois des outils numériques simples et
              utiles pour les clubs sportifs.
            </p>
          </div>
        </div>
      </div>

      <div className="p-5 sm:p-6">
        <div className="grid gap-3 sm:grid-cols-3">
          <AuthorInfo icon={FaLaptopCode} label="Activité" value="Applications web" />
          <AuthorInfo icon={FaUserTie} label="Terrain" value="Clubs & associations" />
          <AuthorInfo icon={FaEnvelope} label="Contact" value="monappliclub@gmail.com" />
        </div>

        <div className="mt-5 flex flex-col gap-3 sm:flex-row sm:flex-wrap">
          <a
            href="mailto:monappliclub@gmail.com"
            className="inline-flex min-h-12 items-center justify-center gap-2 rounded-2xl bg-slate-100 px-4 text-sm font-bold text-slate-700 transition hover:bg-slate-200 active:scale-95 dark:bg-slate-800 dark:text-slate-200 dark:hover:bg-slate-700"
          >
            <FaEnvelope />
            Me contacter
          </a>

          <a
            href="tel:+33680727707"
            className="inline-flex min-h-12 items-center justify-center gap-2 rounded-2xl bg-slate-100 px-4 text-sm font-bold text-slate-700 transition hover:bg-slate-200 active:scale-95 dark:bg-slate-800 dark:text-slate-200 dark:hover:bg-slate-700"
          >
            <FaPhoneAlt />
            06 80 72 77 07
          </a>

          <VKardLink />
        </div>
      </div>
    </section>
  );
}

function AuthorInfo({ icon: Icon, label, value }) {
  return (
    <div className="rounded-2xl border border-slate-200 bg-slate-50 p-4 dark:border-slate-800 dark:bg-slate-950">
      <div className="flex items-center gap-2 text-xs font-bold uppercase tracking-[0.16em] text-slate-400">
        <Icon />
        {label}
      </div>

      <p className="mt-2 break-words text-sm font-bold text-slate-900 dark:text-white">
        {value}
      </p>
    </div>
  );
}